import Boards from './models/Boards'
import Lists from './models/Lists'
import Cards from './models/Cards'

export const BoardsDB = Boards
export const ListsDB = Lists
export const CardsDB = Cards
